exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".variants[data-v-472feb95]{position:relative}.variants-holder[data-v-472feb95]{position:absolute;top:-80px;bottom:0;left:0;pointer-events:none}.panel-heading .left[data-v-472feb95]{display:inline-flex;align-items:center;width:auto}.panel-heading .left .image[data-v-472feb95]{margin-right:15px;cursor:pointer;display:flex;border:1px solid #dbdbdb;background-color:#f5f5f5}.panel-heading .left .image img[data-v-472feb95]{margin:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/tmp/build_919341db/resources/nuxt/assets","/static":"/tmp/build_919341db/resources/nuxt/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-472feb95","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/nuxt/pages/office/products/fittings/_id/_variant.vue
// module id = mGYr
// module chunks = 3